import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { logout, authenticationInProgress } from '../../ducks/Auth.duck';
import { Topbar } from '../../components';
/**
 * TODO: get rid of TopbarContainerComponent, just use Topbar
 */
export const TopbarContainerComponent = props => <Topbar {...props} />;

const mapStateToProps = state => {
    // Topbar needs isAuthenticated
    const { isAuthenticated, authInfoLoaded } = state.Auth;
    // Topbar needs user info.
    const {
        currentUser,
        currentUserHasPublishedListings,
        currentUserHasOrders,
        sendVerificationEmailInProgress,
        sendVerificationEmailError,
    } = state.user;
    const { disableScrollRequests } = state.UI;
    const { wishlistListingStatusChanged } = state.FavoritePage;

    return {
        authInProgress: authenticationInProgress(state),
        currentUser,
        currentUserHasPublishedListings,
        currentUserHasOrders,
        isAuthenticated,
        sendVerificationEmailInProgress,
        sendVerificationEmailError,
        wishlistListingStatusChanged,
        disableScrollRequests,
        authInfoLoaded,
    };
};

const mapDispatchToProps = dispatch => ({
    onLogout: historyPush => dispatch(logout(historyPush)),
    onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const TopbarContainer = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(TopbarContainerComponent);

export default TopbarContainer;
